var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07106 16.6567C8.18957 19.7752 13.2663 19.7752 16.3848 16.6567C19.5033 13.5382 19.5033 8.46154 16.3848 5.34303C13.2663 2.22452 8.18957 2.22452 5.07106 5.34303C1.95255 8.46154 1.95255 13.5382 5.07106 16.6567ZM4.36395 17.3638C7.87299 20.8729 13.5828 20.8729 17.0919 17.3638C20.6009 13.8548 20.6009 8.14496 17.0919 4.63592C13.5828 1.12689 7.87298 1.12689 4.36395 4.63593C0.854919 8.14496 0.85492 13.8548 4.36395 17.3638Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.69244 10.8784L9.57679 12.6265L14.3025 8L15 8.53651L9.57679 13.8667L7 11.43L7.69244 10.8784Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck4);
export default __webpack_public_path__ + "static/media/check4.25c9cb2de78d94fafd0e46890a11d6b8.svg";
export { ForwardRef as ReactComponent };